import React, { useState } from 'react';
import { University, Info, GraduationCap, Briefcase } from 'lucide-react';
import BCMResourcesOverview from './BCMResourcesOverview';
import BCMResourcesTrainees from './BCMResourcesTrainees';
import BCMResourcesFaculty from './BCMResourcesFaculty';
import TabStrip from '../shared/TabStrip';
import ToolHeader from '../shared/ToolHeader';

export const BCM_ACCENT = '#334155';

const TABS = [
  { id: 'overview', label: 'Overview', icon: Info },
  { id: 'trainees', label: 'GME Trainees', icon: GraduationCap },
  { id: 'faculty', label: 'Faculty', icon: Briefcase },
];

const BCMResourcesScreen = ({ onBack }) => {
  const [activeTab, setActiveTab] = useState('overview');
  return (
    <div className="max-w-md mx-auto bg-gray-50 dark:bg-gray-900 min-h-screen">
      <ToolHeader title="Baylor College of Medicine" subtitle="College-wide resources" icon={University} accent={BCM_ACCENT} backLabel="Home" onBack={onBack} />
      <TabStrip tabs={TABS} activeTab={activeTab} onChange={setActiveTab} activeClass="border-slate-700 dark:border-slate-300 text-slate-700 dark:text-slate-200" />
      <div className="p-6">
        {activeTab === 'overview' && <BCMResourcesOverview />}
        {activeTab === 'trainees' && <BCMResourcesTrainees />}
        {activeTab === 'faculty' && <BCMResourcesFaculty />}
      </div>
      <div className="h-8" />
    </div>
  );
};

export default BCMResourcesScreen;
